<section class=" min-h-screen py-24 px-8 md:py-32 md:px-24" [style.background-color]="this.loadeddata?.SeconndaryColor">
  <div class="max-w-5xl mx-auto text-center">
    <h2 class="text-3xl md:text-4xl font-extrabold text-[#181818] mb-4">
		{{this.loadeddata['Name']}} is on T-Mobile's 5G network.
    </h2>
    <p class="text-md text-[#181818] mb-10">
      Enter your address or zip code to see a detailed coverage map of your service area.
    </p>

    <div class="w-full h-[600px] rounded-lg overflow-hidden border border-gray-300 shadow-lg">
      <iframe
        src="https://mvnoc.ai/coverage-map"
        class="w-full h-full"
        loading="lazy"
        title="T-Mobile Coverage Map"
      ></iframe>
    </div>
  </div>
</section>